export default "__VITE_ASSET__0ea22ab8__"